export default "__VITE_ASSET__DTEvztSo__"